// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import {menuItems_admin,menuItems_user} from 'menu-items';
import authService from 'component/Authentication/authService';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  if(authService.getCurrentUserRole()==="Admin" || authService.getCurrentUserRole()==="SuperAdmin"){
    const navItems = menuItems_admin.items.map((item) => {
      switch (item.type) {
        case 'group':
          return <NavGroup key={item.id} item={item} />;
        default:
          return (
            <Typography key={item.id} variant="h6" color="error" align="center">
              Menu Items Error
            </Typography>
          );
      }
    });
  
    return <>{navItems}</>;
    
  }
  if(authService.getCurrentUserRole()==="User"){
    const navItems = menuItems_user.items.map((item) => {
      switch (item.type) {
        case 'group':
          return <NavGroup key={item.id} item={item} />;
        default:
          return (
            <Typography key={item.id} variant="h6" color="error" align="center">
              Menu Items Error
            </Typography>
          );
      }
    });
  
    return <>{navItems}</>;

  }

};

export default MenuList;
